export const LOWER_BOUND_BIRTH_YEARS_DIFFERENCE = 120;
